var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.identityStatus)?_c('span',[_vm._v("\n        "+_vm._s(_vm.identityStatus)+"\n    ")]):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }